module.exports = __webpack_public_path__ + "img/About.7213fa3c.png";